module.exports = __webpack_public_path__ + "static/media/kn.5214fd98.svg";